<template>
  <v-form id="address-select" class=".address-select" ref="form" lazy-validation dense>
    <v-row cols="12" v-for="(chunk, row_index) in offices" :key="row_index">
      <v-col cols="6" v-for="(office, col_index) in chunk" :key="col_index" align-center>
        <v-card class="mx-auto force-background-grey force-radius" @click="selectLevel(office)" align-center max-width="400" height="100%" hover outlined>
          <v-img :src="base_url + office.img" :alt="office.street"></v-img>
          <v-card-text class="text--primary">
            <div>{{office.desc}}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- MODAL FOR SELECTION OF LEVEL -->
    <v-row justify="center">
      <v-dialog v-model="level_modal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Choose your preferred level</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="center">
                <v-col cols="8">
                  <v-select outlined dense v-model="floor" :items="dropdown_data" item-text="text" item-value="floor_id"></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="level_modal = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="validate()">Continue</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-form>
</template>

<script>
  import {mapGetters, mapState} from 'vuex';
  import chunk from 'lodash/chunk';

  export default {
    name: 'AddressSelect',
    components: {
    },
    data: function() {
      return {
        level_modal: false,
        dropdown_data: null,
        rules: {
        },
      }
    },
    computed: {
      ...mapState('service_data', [
        'base_url',
        ]),
      ...mapGetters('service_data', {
        locations: getters => getters.office_locations,
      }),
      offices: function() {
        if(this.$store.state.service_data.internalFlag) {
          console.log("Compiling internal office list");
          return []
        } else {
          return chunk(this.$store.state.service_data.virtualOffices, 2);
        }
      },
      floor: {
        get() {
          return this.$store.state.building_details.floor_id;
        },
        set(value) {
          this.$store.commit('building_details/setFloorId', value);
        }
      }
    },
    methods: {
      validate: function() {
        this.$store.dispatch('service_data/stageSubmission', this.$refs.form).then( next => {
          this.$router.push(next);
        });
      },
      selectLevel: function(office) {
        if (office.level.length > 1) {
          this.dropdown_data = [];
          this.level_modal = true;
          this.$store.commit('building_details/setBuilding', office);
          office.level.forEach((x) => {
            this.dropdown_data.push({
              text: "Level " + x + ", " + office.street,
              floor_id: x,
            });
          });
        } else {
          this.$store.commit('building_details/setFloorId', office.level[0])
          this.$store.commit('building_details/setBuilding', office);
          this.$store.dispatch('service_data/stageSubmission', this.$refs.form).then( next => {
            this.$router.push(next);
          });
        }
      },
    }
  }
</script>
<style scoped>
  form h2 {
    font-size: 29px;
    letter-spacing: -1px;
    font-weight: 400;
  }
  form p {
    margin-top: 20px;
    margin-bottom: 0;
  }
  table, td, th {
    border: 0.5px solid #B7B7B7;
  }
  table {
    width: 100%;
    border-radius: 4px 4px 0 0;
    border-spacing: 0;
  }
  table tr {
    text-align: left;
    font-size: 14px;
  }
  table td {
    padding: 8px;
  }

  .bottom-divider {
    height: 1px;
    background: rgb(136, 136, 136);
  }
  .location-image {
    display: block;
    margin: 0 auto;
    width: 320px;
    height: auto;
  }
  .force-background-grey {
    background-color: rgb(241, 238, 238);
  }
  .force-radius {
    border-radius: 20px;
  }


</style>
